export default __webpack_public_path__ + "static/media/72d3aeb4-7402-40d6-a945-34360316b980.3575dd81.woff2";